import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box, Inline } from '@nib/layout';
import { WarningSystemIcon } from '@nib/icons';
import { Bold } from '@nib-components/copy';
const FixedLineHeight = styled.div`
  line-height: 1;
`;
const HazardNotificationBox = _ref => {
  let {
    details
  } = _ref;
  return React.createElement(Box, {
    background: "accent",
    color: "white",
    alignSelf: "center",
    padding: 4
  }, React.createElement(FixedLineHeight, null, React.createElement(Inline, {
    space: 2,
    align: "center",
    verticalAlign: "center"
  }, React.createElement(WarningSystemIcon, {
    size: 20
  }), React.createElement(Bold, {
    measure: false,
    align: "center"
  }, details))));
};
const HazardNotification = props => {
  const {
    path
  } = props;
  const [hazardNotification, setHazardNotification] = useState();
  const getHazardNotification = async () => {
    var _a, _b, _c;
    try {
      const url = path;
      const response = await fetch(url);
      const json = await response.json();
      const notifications = (_c = (_b = (_a = json === null || json === void 0 ? void 0 : json.data) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.notifications) === null || _c === void 0 ? void 0 : _c.alert;
      return notifications;
    } catch (e) {
      console.log('$$$-getHazardNotification-from-the-server--- ', e);
    }
    return null;
  };
  const fetchData = async () => {
    const hazard = await getHazardNotification();
    setHazardNotification(hazard);
  };
  useEffect(() => {
    void fetchData();
  }, []);
  return React.createElement(React.Fragment, null, hazardNotification && React.createElement(HazardNotificationBox, {
    details: hazardNotification.details
  }));
};
export default HazardNotification;